import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

// PWA Registration
import { registerSW } from 'virtual:pwa-register'

// Register Service Worker with auto-update
const updateSW = registerSW({
  onNeedRefresh() {
    console.log('New content available, please refresh.')
  },
  onOfflineReady() {
    console.log('App ready to work offline.')
  },
})

// StrictMode removed to prevent double API calls in development
// React.StrictMode causes useEffect to run twice intentionally in dev mode
// This was causing 4x API calls when combined with other re-renders
ReactDOM.createRoot(document.getElementById('root')).render(
  <App />
)
